module.exports = __webpack_public_path__ + "static/media/opening.514e7298.jpg";